import React from "react";
import Navbar from "../../components/navbar/Navbar";
import AllPost from "../../components/post/allPost/AllPost";
import PostCard from "../../components/post/allPost/PostCard";

const Search = () => {
  return (
    <div>
      <Navbar
        style={{ background: "var(--hijauIpmKarawang)", position: "static" }}
      />
      <AllPost />
    </div>
  );
};

export default Search;
